import React from 'react';

const AplazameKo = () => {
  return (
    <div className="container text-center p-5">
      <h1>❌ Payment Rejected</h1>
      <p>Unfortunately, Aplazame rejected your payment. You can try a different payment method.</p>
    </div>
  );
};

export default AplazameKo;
